import { render, staticRenderFns } from "./BrandTabSelect.vue?vue&type=template&id=4f5659d6&scoped=true"
import script from "./BrandTabSelect.vue?vue&type=script&lang=js"
export * from "./BrandTabSelect.vue?vue&type=script&lang=js"
import style0 from "./BrandTabSelect.vue?vue&type=style&index=0&id=4f5659d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5659d6",
  null
  
)

export default component.exports